import React, { useMemo } from 'react';
export const TextHighlighter = ({
    contentString,
    toMatch, // string, array of string, [{toMatchText: '', highlightCustomStyle: ''}],
    regexPatterns, // [{pattern: RegExp, highlightCustomStyle: {}}] — regex-based matching
    typography={className: 'text_body_light'},
    highlightStyle={background: "rgba(255, 172, 18, 0.4)", textTransform: "capitalize"},
    isInline = false,
    ...props
}) => {
    let toMatches = Array.isArray(toMatch) ? toMatch : [toMatch];
    toMatches = toMatches.map((item) => {
        if (item !== null && item !== undefined) {
            if (typeof item === 'number') {
                item = item.toString();
            }
            return typeof item === 'string' ? { toMatchText: item } : item;
        }
        return null;
    }).filter(item => item !== null);
    let toMatchStr = toMatches.map((toMatch) => toMatch?.toMatchText).join(", ")
    
    const replaceContent = useMemo(() => {
        if ((!toMatch && !regexPatterns) || !contentString) return contentString;

        let allPatternParts = [];

        // Literal string patterns (escaped)
        if (toMatches.length > 0) {
            let literalParts = toMatches.map(tm => tm.toMatchText?.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).filter(Boolean);
            if (literalParts.length > 0) allPatternParts.push(...literalParts);
        }

        // Regex patterns (raw, not escaped)
        let regexPats = regexPatterns || [];
        if (regexPats.length > 0) {
            let regexParts = regexPats.map(rp => rp.pattern.source);
            allPatternParts.push(...regexParts);
        }

        if (allPatternParts.length === 0) return contentString;

        let combinedRegex = new RegExp(`(${allPatternParts.join('|')})`, 'gi');

        let highlightedHtml = <>
            {
            contentString.split(combinedRegex).map((section, index) => {
                if (!section) return null;

                // Check literal matches first
                let matchedPattern = toMatches.filter(tm => tm.toMatchText?.toLowerCase() === section?.toLowerCase())[0];
                if (matchedPattern) {
                    let highlightCustomStyle = matchedPattern.highlightCustomStyle || highlightStyle;
                    return (
                        <span key={index} style={highlightCustomStyle}>
                            {section}
                        </span>
                    )
                }

                // Check regex matches
                for (let rp of regexPats) {
                    let testRegex = new RegExp(`^(?:${rp.pattern.source})$`, 'i');
                    if (testRegex.test(section)) {
                        return (
                            <span key={index} className={rp.highlightClassName || ''} style={rp.highlightCustomStyle || (rp.highlightClassName ? {} : highlightStyle)}>
                                {section}
                            </span>
                        )
                    }
                }

                return section;
            })}
        </>
        return highlightedHtml;
    }, [contentString, highlightStyle, toMatchStr, regexPatterns]);

    if (!contentString) return <div></div>;
    return isInline ? <span className={typography.className} style={props.style}>{replaceContent}</span> : <div className={typography.className} style={props.style}>{replaceContent}</div>;
};

export const escapeRegex = (string) => {
    return string.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&');
};
